/* ==========================================================================
   Wine club offer in the cart drawer
   ==========================================================================
   Loaded only when Theme settings > Cart > "Offer wine club membership in
   the cart drawer" is on (sections/cart-drawer.liquid). Styles: custom.css
   section 14, "Club offer".

   Every wine carries what the offer needs, printed in Liquid by
   snippets/cart-line-items.liquid, so nothing is fetched to draw it:
     data-club       {"f": full unit price, "s": the plan on the line or
                      null, "p": {plan id: unit price on that plan},
                      "b": bottles in one of it, when more than one
                      (a dozen pack is 12), "g": 1 on a gift card}
     data-club-note  what a wine that can't join says

   Joining puts the plan on each eligible wine through /cart/change.js, one
   line at a time, keyed by line key, then sets the cart attributes WineHub
   reads. WineHub makes the membership from those when the order is placed;
   nothing here talks to WineHub. Leaving takes the plans off. A failure
   part-way puts back what had already changed. theme.js then redraws the
   cart (theme:cart:refresh), and this redraws the offer when it hears
   theme:cart:change.

   Joining in the drawer also sets club_join_source = "Cart drawer" on the
   cart, so the order shows where the membership started, and so this script
   only ever manages a club order it started: a cart that WineHub's own join
   flow or a product page put plans on is left exactly as it is.

   A visitor who came in through the cellar door QR code joins as an
   in-store sign-up, marked as WineHub's own sign-up is marked for them:
   the attributes custom.js gives for that tab (window.crittendenPosSignUp)
   go on with the rest, and come off on leaving, from any tab, while the
   cart carries them (data-pos-sign-up).

   Once joined, the panel asks for what WineHub's own sign-up asks for:
   delivery instructions (its five choices, or Other with a box), optional,
   and a date of birth, required. Members must be 18 or over, so Check out
   waits until the date is of someone 18 or over today, opening the panel
   at the date. The cart page has no panel, so it draws the same fields
   under its status line while a club order is on the cart. This holds the
   site's own Check out only: nothing at Shopify's checkout checks the date.
   They go on the cart as wh_deliveryInstructions and
   wh_dob (YYYY-MM-DD), the attributes WineHub's sign-up sends, saved as
   they change and sent again with the cart form at Check out, so a quick
   click can't lose them. They come off with the membership. The panel
   opens on its own once, after joining, so they are seen.

   The cart page doesn't draw the drawer, so there the page's cart carries
   a bare offer (sections/cart.liquid, data-cd-guard): no bar or panel, but
   the same rules for a club order started in the drawer, with the status
   line under the subtotal saying what changed.

   While the club order is changing, Check out waits, as a checkout then
   would carry it half done, and the status line says so. The next press
   goes.

   Events for Customer events (Settings > Customer events, custom pixel):
   club_offer_opened, club_offer_joined, club_offer_removed and
   club_offer_failed, published with Shopify.analytics.publish.

   Unverified until the console test on staging: what /cart/change.js does
   to line keys and order when a plan goes on or comes off. Keys are read
   from each response rather than assumed, and nothing relies on order.
   ========================================================================== */

(function () {
  'use strict';

  /* The drawer, or on the cart page, which doesn't draw it, the page's cart.
     There the offer is bare (guard): the rules, without the bar. */
  var drawer = document.getElementById('cart-drawer') || document.querySelector('[data-cart-page]');
  var club = drawer && drawer.querySelector('[data-cd-offer]');
  if (!club) return;
  var guard = club.hasAttribute('data-cd-guard');

  /* Selling plan IDs. They match WineHub's headless API. The dates are the
     club's fixed rebill dates (month, day), when the card is charged; the
     wines ship in the first week of the next month, as the season starts. One
     under 30 days away is skipped, as the club does for a new member. Change
     them here if the club's schedule changes, or the 30 days in WineHub. The
     names are the site's plan names, the same on every page; WineHub's groups
     keep theirs. */
  var PLANS = {
    '1138655281': { tier: 'gold', name: 'Gold Quarterly', detail: '6 bottles every season', cycle: '', min: 6, off: 15, every: '3 months', dates: [[2, 26], [5, 26], [8, 31], [11, 26]] },
    '1138491441': { tier: 'gold', name: 'Gold Biannual', detail: '12 bottles in summer and winter', cycle: 'summer and winter', min: 12, off: 15, every: '6 months', dates: [[5, 26], [11, 26]] },
    '1138524209': { tier: 'gold', name: 'Gold Biannual', detail: '12 bottles in autumn and spring', cycle: 'autumn and spring', min: 12, off: 15, every: '6 months', dates: [[2, 26], [8, 31]] },
    '1161887793': { tier: 'plat', name: 'Platinum', detail: '12 bottles every season', cycle: '', min: 12, off: 20, every: '3 months', dates: [[2, 26], [5, 26], [8, 31], [11, 26]] }
  };
  var ORDER = ['1138655281', '1138491441', '1138524209', '1161887793'];
  var GOLD = '1138655281';
  var PLATINUM = '1161887793';
  var BIANNUAL = ['1138491441', '1138524209'];
  var MIN = 6;
  var MARK = 'club_join_source';
  var MARK_VALUE = 'Cart drawer';
  /* The keys window.crittendenPosSignUp() returns (custom.js), taken off
     again on leaving. */
  var IN_STORE = ['wh_pos_sign_up', 'wh_sign_up_location', 'wh_staff', 'wh_staff_name', 'wh_sales_channel_name', 'acquisition_source'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  /* WineHub's sign-up offers these delivery instructions and sends the words
     themselves. Members must be 18 or over: a younger date of birth isn't
     sent, as in WineHub's sign-up. */
  var DELIVERY = ['Leave at door', 'Leave with concierge', 'Ring doorbell', 'Leave in safe place', 'Signature required'];
  var OTHER = 'other';
  var ADULT = 18;

  /* Kept short. The club page has the full picture. */
  var BENEFITS = [
    ['Member pricing', '15 to 20% off most wines, all year, not only in deliveries.'],
    ['Your wines', 'Choose what goes in every pack.'],
    ['Club wines', 'Most of our range. A few, like museum releases, are one-off purchases.'],
    ['Your delivery', 'Free Australia-wide, or collect after a tasting.'],
    ['Cellar door', 'Complimentary tastings.']
  ];

  /* The bare offer has nothing to draw into; a stand-in keeps the drawer's
     listeners harmless there. */
  var inner = club.querySelector('[data-cd-inner]') || document.createElement('div');
  /* Where the delivery details are drawn: the panel, or on the cart page
     its own slot. */
  var fields = (guard && club.querySelector('[data-cd-fields]')) || inner;
  var statusLine = club.querySelector('[data-cd-status]');
  var notes = [].slice.call(drawer.querySelectorAll('[data-cd-note]'));
  var defaultNote = notes.length ? notes[0].textContent.trim() : '';
  /* Blank for a non-member, else gold, plat or paused; on the cart page
     member or paused, as only whether there's a membership matters there. */
  var member = club.getAttribute('data-member') || '';
  var tierName = club.getAttribute('data-tier-name') || '';
  var clubUrl = club.getAttribute('data-club-url') || '';
  var contactUrl = club.getAttribute('data-contact-url') || '';
  var caseSize = club.getAttribute('data-case-size') || '';
  var marked = club.getAttribute('data-join-source') === MARK_VALUE;
  var inStore = club.getAttribute('data-pos-sign-up') === 'true';
  var signedIn = club.getAttribute('data-signed-in') === 'true';
  var signinUrl = club.getAttribute('data-signin-url') || '';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* The delivery details: as chosen (details), as last saved to the cart
     (onCart) and as typed (draft). Other's words are kept while another
     choice is picked, and a date that isn't sent stays in the box with a
     note under it. */
  var details = { delivery: club.getAttribute('data-delivery') || '', dob: club.getAttribute('data-dob') || '' };
  var onCart = { delivery: details.delivery, dob: details.dob };
  var draft = freshDraft(details);
  var saveTimer = null;
  var openTimer = null;

  var ui = { open: false, info: false, busy: '', busyPlan: '', celebrate: null, state: '', openAfterJoin: false };
  var lastHtml = null;
  var failedFor = '';

  /* ---- reading the cart ------------------------------------------------ */

  function readLines() {
    var els = drawer.querySelectorAll('[data-items-holder] [data-item]');
    return [].slice.call(els).map(function (el) {
      var data = {};
      try { data = JSON.parse(el.getAttribute('data-club') || '{}'); } catch (error) {}
      var field = el.querySelector('input[name="updates[]"]');
      var key = el.getAttribute('data-item') || '';
      return {
        el: el,
        key: key,
        variant: Number(key.split(':')[0]),
        q: field ? parseInt(field.value, 10) || 0 : 0,
        full: Number(data.f) || 0,
        per: Number(data.b) || 1,
        gift: !!data.g,
        plan: data.s == null ? '' : String(data.s),
        prices: data.p || {}
      };
    });
  }

  function canTake(line, id) { return line.prices[id] != null; }

  /* Whether a wine can go on any of the plans given (all of them if none
     are). Each plan has its own wines in Shopify: a dozen pack goes on the
     twelve-bottle plans but not on Gold Quarterly. */
  function canJoin(line, ids) {
    return (ids || ORDER).some(function (id) { return canTake(line, id); });
  }

  /* Bottles, not lines: a dozen pack is 12. Gift cards aren't bottles. */
  function bottlesIn(line) { return line.gift ? 0 : line.q * line.per; }

  function totalBottles(lines) {
    return lines.reduce(function (n, l) { return n + bottlesIn(l); }, 0);
  }

  function bottles(lines, id) {
    return lines.reduce(function (n, l) { return canTake(l, id) ? n + bottlesIn(l) : n; }, 0);
  }

  /* A plan is there to join once the wines on its selling plan reach its
     minimum: a dozen pack counts toward Platinum and Gold Biannually, whose
     plans it's on, but not toward Gold Quarterly. Every wine on a plan counts
     and joins, WineHub's Add-on only and Hide from sign-up wines included,
     though its own sign-up leaves those out. */
  function canOffer(lines, id) {
    return bottles(lines, id) >= PLANS[id].min;
  }

  function saving(lines, id) {
    return lines.reduce(function (s, l) { return canTake(l, id) ? s + (l.full - l.prices[id]) * l.q : s; }, 0);
  }

  function joinedPlan(lines) {
    for (var i = 0; i < lines.length; i++) if (PLANS[lines[i].plan]) return lines[i].plan;
    return '';
  }

  /* ---- words and numbers ----------------------------------------------- */

  function money(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function' && window.theme.moneyFormat) {
      return window.theme.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  function nextDate(id) {
    var cutoff = new Date();
    cutoff.setHours(0, 0, 0, 0);
    cutoff.setDate(cutoff.getDate() + 30);
    var best = null;
    for (var y = cutoff.getFullYear(); y <= cutoff.getFullYear() + 1; y++) {
      PLANS[id].dates.forEach(function (md) {
        var d = new Date(y, md[0] - 1, md[1]);
        if (d >= cutoff && (!best || d < best)) best = d;
      });
    }
    return best;
  }

  /* The next charge date in words: 26 November. */
  function nextCharge(id) {
    var d = nextDate(id);
    return d ? d.getDate() + ' ' + MONTHS[d.getMonth()] : '';
  }

  /* The month that delivery ships in, the one after its charge date: a
     season starts on the 1st, so 26 November ships in early December. */
  function nextShip(id) {
    var d = nextDate(id);
    return d ? MONTHS[(d.getMonth() + 1) % 12] : '';
  }

  /* The two Gold Biannually cycles run six months apart. The cart offers
     the one whose next delivery lands furthest from this order and leaves
     the other to the full sign-up. */
  function offered(lines) {
    var ids = ORDER.filter(function (id) { return canOffer(lines, id); });
    var both = ids.filter(function (id) { return BIANNUAL.indexOf(id) > -1; });
    if (both.length > 1) {
      var keep = both.reduce(function (a, b) { return nextDate(b) > nextDate(a) ? b : a; });
      ids = ids.filter(function (id) { return BIANNUAL.indexOf(id) === -1 || id === keep; });
    }
    return ids;
  }

  /* ---- drawing ---------------------------------------------------------- */

  function bar(mod, eyebrow, lead) {
    return '<button type="button" class="cd-bar cd-bar--button' + (mod ? ' ' + mod : '') + '"' +
      ' aria-controls="cd-panel" aria-expanded="false" data-cd="toggle" data-cd-focus="toggle">' +
      '<span class="cd-bar__eyebrow kicker">' + eyebrow + '</span>' +
      '<span class="cd-bar__lead">' + lead + '</span>' +
      '<span class="cd-chev" aria-hidden="true"></span></button>';
  }

  function panel(content) {
    return '<div class="cd-panel" id="cd-panel"><div class="cd-panel__clip"><div class="cd-panel__in">' + content + '</div></div></div>';
  }

  /* When some of the cart can't join, say how much of it counts; each wine
     that doesn't carries its own note. Gift cards aren't bottles. */
  function counted(lines, count) {
    var total = totalBottles(lines);
    if (count >= total) return '';
    return '<p class="cd-count">' + count + ' of the ' + total + ' bottles in your cart ' + (count === 1 ? 'counts' : 'count') + ' toward a membership.</p>';
  }

  /* A member who hasn't signed in looks like a non-member here, and joining
     would start a second membership. */
  function signIn() {
    if (signedIn || !signinUrl) return '';
    return '<p class="cd-signin">Already a member? <a class="cd-link" href="' + signinUrl + '" data-cart-signin data-cd-focus="signin">Sign in first</a>, so you don\'t end up with two memberships.</p>';
  }

  function benefits() {
    return '<button type="button" class="cd-link cd-more" aria-controls="cd-detail" aria-expanded="false" data-cd="info" data-cd-focus="info">How membership works</button>' +
      '<div class="cd-detail" id="cd-detail" hidden><dl class="cd-detail__list">' +
      BENEFITS.map(function (row, r) {
        return '<div class="cd-detail__row" style="--r:' + r + '"><dt>' + row[0] + '</dt><dd>' + row[1] + '</dd></div>';
      }).join('') + '</dl>' +
      (clubUrl ? '<p class="cd-panel__meta"><a class="cd-link" href="' + clubUrl + '" data-cd-focus="benefits">See all member benefits</a></p>' : '') +
      '</div>';
  }

  /* Delivery instructions and date of birth, once joined. Drawn without their
     values, which fillDetails() puts in, so typing never redraws the panel.
     The two hidden fields go with the cart form at Check out; an empty one is
     disabled, so it sends nothing. Delivery instructions are optional and
     say so; the date of birth is required (holdCheckout). */
  function deliveryFields() {
    return '<div class="cd-fields">' +
      '<div class="cd-field">' +
        '<label class="cd-field__label" for="cd-delivery">Delivery instructions <span class="cd-field__optional">(optional)</span></label>' +
        '<select class="cd-field__input" id="cd-delivery" data-cd-field="delivery" data-cd-focus="delivery">' +
          '<option value="">No instructions</option>' +
          DELIVERY.map(function (words) { return '<option value="' + escapeHtml(words) + '">' + escapeHtml(words) + '</option>'; }).join('') +
          '<option value="' + OTHER + '">Other</option>' +
        '</select>' +
      '</div>' +
      '<div class="cd-field" data-cd-other hidden>' +
        '<label class="cd-field__label" for="cd-delivery-other">Your instructions</label>' +
        '<textarea class="cd-field__input" id="cd-delivery-other" rows="2" data-cd-field="other" data-cd-focus="other"></textarea>' +
      '</div>' +
      '<div class="cd-field">' +
        '<label class="cd-field__label" for="cd-dob">Date of birth</label>' +
        '<input class="cd-field__input" type="date" id="cd-dob" autocomplete="bday" aria-required="true" min="1900-01-01" max="' + isoDate(adultSince()) + '" data-cd-field="dob" data-cd-focus="dob">' +
        '<p class="cd-field__note" id="cd-dob-note" data-cd-dob-note hidden></p>' +
      '</div>' +
      '<input type="hidden" form="cartForm" name="attributes[wh_deliveryInstructions]" data-cd-send="delivery" disabled>' +
      '<input type="hidden" form="cartForm" name="attributes[wh_dob]" data-cd-send="dob" disabled>' +
    '</div>';
  }

  /* Puts the details into the fields. After a redraw (force) every field
     is filled; otherwise the one being typed in is left alone. */
  function fillDetails(force) {
    var select = fields.querySelector('[data-cd-field="delivery"]');
    if (!select) return;
    var other = fields.querySelector('[data-cd-field="other"]');
    var dob = fields.querySelector('[data-cd-field="dob"]');
    var note = fields.querySelector('[data-cd-dob-note]');
    var active = document.activeElement;
    var preset = DELIVERY.indexOf(details.delivery) > -1;
    select.value = draft.other ? OTHER : (preset ? details.delivery : '');
    fields.querySelector('[data-cd-other]').hidden = !draft.other;
    if (force || active !== other) other.value = draft.text;
    if (force || active !== dob) dob.value = draft.dob;
    note.textContent = draft.note;
    note.hidden = !draft.note;
    if (draft.note) {
      dob.setAttribute('aria-describedby', 'cd-dob-note');
      dob.setAttribute('aria-invalid', 'true');
    } else {
      dob.removeAttribute('aria-describedby');
      dob.removeAttribute('aria-invalid');
    }
    sendWith('delivery', details.delivery.trim());
    sendWith('dob', details.dob);
  }

  function sendWith(kind, value) {
    var field = fields.querySelector('[data-cd-send="' + kind + '"]');
    if (!field) return;
    field.value = value;
    field.disabled = !value;
  }

  function freshDraft(from) {
    var custom = !!from.delivery && DELIVERY.indexOf(from.delivery) === -1;
    return { other: custom, text: custom ? from.delivery : '', dob: from.dob, note: '' };
  }

  /* The latest birth date of someone 18 or over today. */
  function adultSince() {
    var day = new Date();
    day.setHours(0, 0, 0, 0);
    day.setFullYear(day.getFullYear() - ADULT);
    return day;
  }

  function isoDate(day) {
    return day.getFullYear() + '-' + ('0' + (day.getMonth() + 1)).slice(-2) + '-' + ('0' + day.getDate()).slice(-2);
  }

  /* A date box's value: true for a birth date 18 or more years ago, false
     for a later one, null for none, or one that can't be a birth date. */
  function adult(value) {
    var parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!parts) return null;
    var born = new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]));
    var today = new Date();
    if (born.getFullYear() < 1900 || born.getMonth() !== Number(parts[2]) - 1 || born > today) return null;
    return born <= adultSince();
  }

  function forNonMember(lines) {
    var joined = joinedPlan(lines);
    var busy = ui.busy;

    if (joined && !marked) return { state: 'external', tier: 'gold', html: '', inPlay: null };

    if (joined) {
      var plan = PLANS[joined];
      var n = bottles(lines, joined);
      var title = plan.name + (plan.cycle ? ', ' + plan.cycle : '');
      return { state: 'joined', tier: plan.tier, inPlay: [joined], html:
        bar('cd-bar--on', 'Membership added', busy === 'leave' ? 'Removing' : plan.name) +
        panel('<h3 class="cd-panel__title">' + title + '</h3>' +
          '<p class="cd-panel__body">These ' + plural(n, 'bottle', 'bottles') + ' ship now at ' + plan.off + '% off. Your next delivery is charged on ' + nextCharge(joined) + ' and ships in early ' + nextShip(joined) + '. Tastings at the cellar door are complimentary from today.</p>' +
          deliveryFields() +
          '<p class="cd-panel__meta"><button type="button" class="cd-link" data-cd="leave" data-cd-focus="leave"' + (busy ? ' aria-disabled="true"' : '') + '>Remove membership</button></p>') };
    }

    if (!lines.some(function (l) { return canJoin(l); })) return { state: 'none', tier: 'gold', html: '', inPlay: null };

    /* Best saving first, so the plan the bar promises is the first one in
       the panel, even where the panel has to scroll. */
    var ids = offered(lines).sort(function (a, b) { return saving(lines, b) - saving(lines, a); });

    if (!ids.length) {
      /* Short of every plan: aim at the smallest one the cart could join,
         which is Gold Quarterly unless its wines only suit the dozen plans. */
      var near = ORDER.filter(function (id) {
        return lines.some(function (l) { return canTake(l, id); });
      }).reduce(function (a, b) { return PLANS[b].min < PLANS[a].min ? b : a; }, GOLD);
      var have = bottles(lines, near);
      var short = PLANS[near].min - have;
      return { state: 'under', tier: 'gold', inPlay: ORDER, html:
        bar('cd-bar--quiet', 'Wine Club', plural(short, 'more bottle', 'more bottles') + ' to a membership') +
        panel('<h3 class="cd-panel__title">' + (PLANS[near].min === 12 ? 'Twelve' : 'Six') + ' bottles is all it takes</h3>' +
          '<p class="cd-panel__body">Members save ' + PLANS[near].off + '% on most wines all year, not only on deliveries.</p>' +
          counted(lines, have) + benefits()) };
    }

    var best = ids[0];
    var count = bottles(lines, best);
    var joinable = lines.reduce(function (n, l) { return canJoin(l, ids) ? n + bottlesIn(l) : n; }, 0);
    var plans = ids.map(function (id) {
      var p = PLANS[id];
      var adding = busy === 'join' && ui.busyPlan === id;
      return '<li><button type="button" class="cd-plan" data-tier="' + p.tier + '" data-cd="join" data-plan="' + id + '" data-cd-focus="plan-' + id + '"' +
        (busy ? ' aria-disabled="true"' : '') + '>' +
        '<span><span class="cd-plan__name">' + p.name + '</span>' +
        '<span class="cd-plan__detail">' + p.detail + ' &middot; next in early ' + nextShip(id) + '</span>' +
        leftOut(lines, ids, id) + '</span>' +
        '<span class="cd-plan__save">' + (adding ? 'Adding' : 'Save ' + money(saving(lines, id))) + '</span></button></li>';
    }).join('');
    var toPlatinum = PLANS[PLATINUM].min - bottles(lines, PLATINUM);

    return { state: 'can', tier: 'gold', inPlay: ids, html:
      bar('', 'Wine Club', busy === 'join' ? 'Adding the membership' : 'Join and save ' + money(saving(lines, best))) +
      panel('<h3 class="cd-panel__title">Make this order your first delivery</h3>' +
        '<p class="cd-panel__body">Your membership starts today with these ' + plural(count, 'bottle', 'bottles') + '. They become your standing order.</p>' +
        counted(lines, joinable) +
        signIn() +
        '<ul class="cd-plans" role="list">' + plans + '</ul>' +
        (toPlatinum > 0 ? '<p class="cd-nudge"><b>' + plural(toPlatinum, 'more bottle', 'more bottles') + '</b> unlocks Platinum, at 20% off.</p>' : '') +
        benefits()) };
  }

  /* On a plan's row: what in the cart could join another plan here but not
     this one, like a dozen pack under Gold Quarterly. */
  function leftOut(lines, ids, id) {
    var out = lines.filter(function (l) { return canJoin(l, ids) && !canTake(l, id); });
    if (!out.length) return '';
    var what = out.length === 1
      ? escapeHtml(out[0].el.getAttribute('data-item-title') || 'One wine') + ' stays a one-off purchase'
      : out.length + ' of your wines stay one-off purchases';
    return '<span class="cd-plan__note">' + what + '</span>';
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Gold members see what this order would cost on Platinum. Changing tier
     is a conversation, so it links to the team rather than doing it here. */
  function forGold(lines) {
    var extra = lines.reduce(function (s, l) {
      var gold = [GOLD].concat(BIANNUAL).filter(function (id) { return canTake(l, id); })[0];
      return gold && canTake(l, PLATINUM) ? s + (l.prices[gold] - l.prices[PLATINUM]) * l.q : s;
    }, 0);
    if (extra <= 0) return null;
    return { state: 'member', tier: 'gold', html:
      bar('', 'Your membership', tierName) +
      panel('<h3 class="cd-panel__title">Platinum</h3>' +
        '<p class="cd-panel__body">12 bottles every season at 20% off. On this order it would save you a further ' + money(extra) + '.</p>' +
        (contactUrl ? '<p class="cd-panel__meta"><a class="cd-link" href="' + contactUrl + '" data-cd-focus="contact">Talk to us about Platinum</a></p>' : '')) };
  }

  function render() {
    var lines = readLines();
    var view = null;
    if (!member) view = forNonMember(lines);
    else if (member === 'gold') view = forGold(lines);

    /* The bare offer draws nothing: the state is all the rules need. */
    if (guard) {
      if (view) ui.state = view.state;
      drawPageFields();
      return;
    }

    /* Platinum and paused members, and Gold members with nothing to gain,
       keep the bar the server drew. */
    if (view) {
      if (view.html !== lastHtml) {
        var active = document.activeElement;
        var focusKey = active && inner.contains(active) ? active.getAttribute('data-cd-focus') : null;
        var caret = focusKey && active.tagName === 'TEXTAREA' ? [active.selectionStart, active.selectionEnd] : null;
        inner.innerHTML = view.html;
        lastHtml = view.html;
        fillDetails(true);
        if (focusKey) {
          var again = inner.querySelector('[data-cd-focus="' + focusKey + '"]') || inner.querySelector('[data-cd-focus="toggle"]');
          if (again) again.focus();
          if (again && caret && again.tagName === 'TEXTAREA') again.setSelectionRange(caret[0], caret[1]);
        }
      }
      if (view.state === 'external') drawer.removeAttribute('data-offer');
      else drawer.setAttribute('data-offer', view.state);
      if (!member) drawer.setAttribute('data-tier', view.tier);
      inner.hidden = view.state === 'none' || view.state === 'external';
      ui.state = view.state;
    }

    if (!member) {
      var joined = view && view.state === 'joined';
      notes.forEach(function (el) { el.textContent = joined ? 'Shipping included on club deliveries.' : defaultNote; });
      var external = view && view.state === 'external';
      markLines(lines, external || !view ? null : view.inPlay);
      recurring(external ? [] : lines);
    }
    applyOpen();
  }

  /* The cart page's fields, while a club order started in the drawer is on
     the cart. Drawn once, so typing never redraws them. */
  function drawPageFields() {
    if (fields === inner) return;
    var want = ui.state === 'joined';
    if (want && !fields.firstChild) {
      fields.innerHTML = deliveryFields();
      fillDetails(true);
    } else if (!want && fields.firstChild) {
      fields.innerHTML = '';
    }
    fields.hidden = !want;
  }

  /* One note on each wine that can't join any plan in play: short of a
     membership, the plan being aimed at; with plans to choose from, all of
     them; once joined, the club order's plan. */
  function markLines(lines, inPlay) {
    var joined = joinedPlan(lines);
    var step = Math.max(45, Math.min(115, Math.round(900 / Math.max(lines.length, 1))));
    drawer.style.setProperty('--cd-step-ms', step + 'ms');
    var i = 0;
    lines.forEach(function (l) {
      var content = l.el.querySelector('.cart__item__content');
      var note = l.el.querySelector('.cd-line-note');
      var wants = !!inPlay && !canJoin(l, inPlay);
      if (wants && !note && content) {
        note = document.createElement('p');
        note.className = 'cd-line-note';
        note.textContent = l.el.getAttribute('data-club-note') || '';
        content.appendChild(note);
      } else if (!wants && note) {
        note.remove();
      }
      var on = joined && l.plan === joined;
      l.el.classList.toggle('cd-on', !!on);
      if (on) l.el.style.setProperty('--i', i++);
    });
    drawer.style.setProperty('--cd-n', i);
  }

  /* What the club order will cost at each delivery, under the subtotal. */
  function recurring(lines) {
    var holder = drawer.querySelector('[data-cart-price-holder]');
    if (!holder) return;
    var old = holder.querySelector('.cd-recurring');
    if (old) old.remove();
    var joined = joinedPlan(lines);
    if (!joined) return;
    var each = lines.reduce(function (s, l) { return l.plan === joined ? s + l.prices[joined] * l.q : s; }, 0);
    var row = document.createElement('div');
    row.className = 'cart__total cd-recurring';
    row.innerHTML = '<span>Recurring</span><span>' + money(each) + ' every ' + PLANS[joined].every + '</span>';
    holder.appendChild(row);
  }

  function applyOpen() {
    var toggle = inner.querySelector('[data-cd="toggle"]');
    var box = inner.querySelector('.cd-panel');
    var more = inner.querySelector('[data-cd="info"]');
    var detail = inner.querySelector('.cd-detail');
    var open = ui.open && !!box;
    club.toggleAttribute('data-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    /* Closing with focus inside the panel (joining, leaving) would drop it
       to the page once the panel goes inert, so hand it to the bar first. */
    if (box && !open && toggle && box.contains(document.activeElement)) toggle.focus();
    if (box) box.inert = !open;
    if (more) {
      more.setAttribute('aria-expanded', String(ui.info));
      more.textContent = ui.info ? 'Less' : 'How membership works';
    }
    if (detail) detail.hidden = !ui.info;
  }

  function closePanel() {
    if (!ui.open && !ui.info) return;
    ui.open = false;
    ui.info = false;
    applyOpen();
  }

  function status(text, isError) {
    if (!statusLine) return;
    statusLine.textContent = text || '';
    statusLine.classList.toggle('is-error', !!isError);
  }

  /* ---- changing the cart ------------------------------------------------ */

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) throw json;
        return json;
      });
    });
  }

  function setPlan(key, quantity, id) {
    return post('cart/change.js', { id: key, quantity: quantity, selling_plan: id ? Number(id) : null });
  }

  /* Put the plan on each target line. Returns what changed, so a failure
     can be walked back. The key changes when a plan goes on, so the new
     one is read from the response. */
  function putOn(targets, id) {
    var done = [];
    var chain = Promise.resolve();
    targets.forEach(function (t) {
      chain = chain.then(function () {
        return setPlan(t.key, t.q, id).then(function (cart) {
          var now = (cart.items || []).filter(function (x) {
            return x.variant_id === t.variant && x.quantity === t.q &&
              (id ? x.selling_plan_allocation && String(x.selling_plan_allocation.selling_plan.id) === id : !x.selling_plan_allocation);
          })[0];
          done.push({ key: now ? now.key : t.key, q: t.q, was: t.plan });
        });
      });
    });
    return chain.then(function () { return done; }, function (error) {
      return rollback(done).then(function () { throw error; });
    });
  }

  function rollback(done) {
    return done.reverse().reduce(function (chain, d) {
      return chain.then(function () {
        return setPlan(d.key, d.q, d.was).catch(function (error) {
          if (window.console) console.error('[wine club] could not put a line back', d, error);
        });
      });
    }, Promise.resolve());
  }

  /* The case size WineHub reads: the plan's own, 6 or 12, however many
     bottles go on it. WineHub's sign-up sends the same when someone picks
     more bottles than the case. */
  function caseSizeFor(id) {
    return PLANS[id] ? PLANS[id].min : 0;
  }

  /* What a tab that came from the cellar door QR code adds to a membership,
     or null (custom.js, "?ref= links and cellar door QR sign-ups"). */
  function inStoreAttributes() {
    try {
      return typeof window.crittendenPosSignUp === 'function' ? window.crittendenPosSignUp() : null;
    } catch (error) {
      return null;
    }
  }

  function attributes(size) {
    var on = size > 0;
    var set = {
      wh_caseSize: on ? String(size) : '',
      wh_sales_channel_name: on ? 'Website' : '',
      wh_subscription: on ? 'true' : ''
    };
    set[MARK] = on ? MARK_VALUE : '';
    var store = on ? inStoreAttributes() : null;
    var clear = !on && inStore;
    if (store) Object.keys(store).forEach(function (key) { set[key] = store[key]; });
    if (clear) IN_STORE.forEach(function (key) { set[key] = ''; });
    /* The delivery details belong to the sign-up, so they come off with
       it, and a save still waiting mustn't put them back. */
    if (!on) {
      clearTimeout(saveTimer);
      set.wh_deliveryInstructions = '';
      set.wh_dob = '';
    }
    return post('cart/update.js', { attributes: set }).then(function () {
      caseSize = on ? String(size) : '';
      if (store) inStore = true;
      if (clear) inStore = false;
      /* Turning the marker off takes effect at the next redraw, once the
         plans are off the lines too. Until then this is still our club
         order, not someone else's. */
      if (on) {
        marked = true;
      } else {
        ui.unmark = true;
        details = { delivery: '', dob: '' };
        onCart = { delivery: '', dob: '' };
        draft = freshDraft(details);
      }
    });
  }

  /* The delivery details go on the cart a moment after the last change,
     only while this is still our club order. */
  function saveSoon() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveDetails, 400);
  }

  function saveDetails() {
    saveTimer = null;
    if (ui.busy) {
      if (ui.busy !== 'leave') saveSoon();
      return;
    }
    if (!marked || !joinedPlan(readLines())) return;
    var want = { delivery: details.delivery.trim(), dob: details.dob };
    if (want.delivery === onCart.delivery && want.dob === onCart.dob) return;
    post('cart/update.js', { attributes: { wh_deliveryInstructions: want.delivery, wh_dob: want.dob } })
      .then(function () {
        if (marked && !ui.unmark) onCart = want;
      }, function () {
        status("Couldn't save your delivery details. Please try again.", true);
      });
  }

  function onDetail(event) {
    var field = event.target;
    var kind = field && field.getAttribute ? field.getAttribute('data-cd-field') : null;
    if (!kind || !fields.contains(field)) return;
    if (kind === 'delivery') {
      draft.other = field.value === OTHER;
      details.delivery = draft.other ? draft.text : field.value;
    } else if (kind === 'other') {
      draft.text = field.value;
      details.delivery = field.value;
    } else if (kind === 'dob') {
      var age = adult(field.value);
      draft.dob = field.value;
      details.dob = age === true ? field.value : '';
      draft.note = age === false ? 'Members must be 18 or over.' : (field.value && age === null ? 'Check the date.' : '');
      if (age === true) status('');
    }
    fillDetails(false);
    saveSoon();
  }

  /* Check out while the club order is changing (joining, new wines going
     on, the membership coming off) would carry it half done, so the cart
     form waits and the status line says so. The change ends by saying what
     happened; the next press goes. custom.js's held Check out after a tap
     lands here too, when the tap changed the club order.
     A club order also waits for a date of birth of someone 18 or over today,
     checked here too, as a date read back from the cart wasn't checked on
     this page. */
  function holdCheckout(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-cart-form]') || !drawer.contains(form)) return;
    if (ui.busy) {
      event.preventDefault();
      status('One moment, your club order is updating.');
    } else if (ui.state === 'joined' && adult(details.dob) !== true) {
      event.preventDefault();
      askForDob();
    }
  }

  /* Opens the panel at the date of birth with a note saying why. */
  function askForDob() {
    if (!draft.note) draft.note = 'Enter your date of birth to join. Members must be 18 or over.';
    fillDetails(false);
    status('Add your date of birth to finish joining the club.', true);
    if (!guard && !ui.open) {
      ui.open = true;
      applyOpen();
    }
    var dob = fields.querySelector('[data-cd-field="dob"]');
    if (dob) dob.focus();
  }

  /* Customer events. Numbers go out in dollars, as analytics tools expect. */
  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (error) {}
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function busy(kind, id) {
    ui.busy = kind || '';
    ui.busyPlan = id || '';
    club.setAttribute('aria-busy', kind ? 'true' : 'false');
    render();
  }

  function totalNow() {
    var el = drawer.querySelector('[data-cart-total]');
    return el ? parseInt(el.getAttribute('data-cart-total'), 10) || 0 : 0;
  }

  /* Join, or bring wines added after joining into the club order. */
  function join(id, onlyThese, done, failed, signature) {
    var lines = readLines();
    var plan = PLANS[id];
    var count = bottles(lines, id);
    if (!plan || !canOffer(lines, id)) return;
    var targets = onlyThese || lines.filter(function (l) { return canTake(l, id) && l.plan !== id; });
    var from = totalNow();
    var saved = saving(lines, id);
    status('');
    busy('join', id);
    putOn(targets, id)
      .then(function (changed) {
        return attributes(caseSizeFor(id)).catch(function (error) {
          return rollback(changed).then(function () { throw error; });
        });
      })
      .then(function () {
        if (!onlyThese) {
          ui.celebrate = { kind: 'join', from: from };
          ui.openAfterJoin = true;
          track('club_offer_joined', { plan: plan.name, plan_id: Number(id), bottles: count, saving: saved / 100, currency: 'AUD', signed_in: signedIn });
        }
        ui.open = false;
        ui.info = false;
        status(done);
      }, function () {
        if (signature) failedFor = signature;
        status(failed, true);
        track('club_offer_failed', { action: onlyThese ? 'add wines' : 'join', plan: plan.name });
      })
      .then(function () {
        busy('');
        refresh();
      });
  }

  function leave(message, signature, reason) {
    var lines = readLines().filter(function (l) { return PLANS[l.plan]; });
    var plan = lines.length ? PLANS[lines[0].plan] : null;
    var from = totalNow();
    status('');
    busy('leave');
    putOn(lines, '')
      .then(function () { return attributes(0); })
      .then(function () {
        ui.celebrate = { kind: 'leave', from: from };
        ui.open = false;
        status(message || 'Membership removed.');
        track('club_offer_removed', { plan: plan ? plan.name : '', reason: reason || (message ? 'under the minimum' : 'customer') });
      }, function () {
        if (signature) failedFor = signature;
        status(reason === 'member' ? "Couldn't take the new membership off your cart. Please reload the page." : "Couldn't remove the membership. Please try again.", true);
        track('club_offer_failed', { action: 'remove', plan: plan ? plan.name : '' });
      })
      .then(function () {
        busy('');
        refresh();
      });
  }

  /* After any change to the cart, keep the club order whole: wines added
     after joining go on the plan, and dropping under the plan's minimum
     takes the membership off and says why. A member who joined here before
     signing in would start a second membership at checkout, so for a
     member the plans come off. */
  function sync() {
    if (ui.busy) return;
    var lines = readLines();
    var id = joinedPlan(lines);
    var signature = lines.map(function (l) { return l.key + 'x' + l.q; }).join('|');
    if (signature === failedFor) return;

    if (!id) {
      if (marked) attributes(0).catch(function () {});
      return;
    }

    if (!marked) return;

    if (member) {
      leave("You're already a member, so we've taken the new membership off your cart.", signature, 'member');
      return;
    }

    var plan = PLANS[id];
    var count = bottles(lines, id);
    if (count < plan.min) {
      leave('Your club order needs ' + plan.min + ' bottles, so the membership has come off. Add wines to join again.', signature);
      return;
    }

    var missing = lines.filter(function (l) { return canTake(l, id) && l.plan !== id; });
    if (missing.length) {
      join(id, missing, 'The new wines are in your club order.', "Couldn't add the new wines to your club order.", signature);
      return;
    }

    if (String(caseSizeFor(id)) !== caseSize) attributes(caseSizeFor(id)).catch(function () {});
  }

  /* ---- motion ------------------------------------------------------------
     The subtotal counting to its new figure is the one movement that
     carries information: it shows the money moving. Only on joining or
     leaving, and not at all with reduced motion. Returns how long the count
     takes, so the panel can wait for it. */

  function celebrate() {
    var c = ui.celebrate;
    ui.celebrate = null;
    if (!c || guard || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
    var cls = c.kind === 'join' ? 'cd-joined' : 'cd-left';
    drawer.classList.add(cls);
    setTimeout(function () { drawer.classList.remove(cls); }, 2400);

    var el = drawer.querySelector('[data-cart-total]');
    var to = totalNow();
    if (!el || !c.from || c.from === to) return 0;
    var n = parseInt(drawer.style.getPropertyValue('--cd-n'), 10) || 0;
    var step = parseInt(drawer.style.getPropertyValue('--cd-step-ms'), 10) || 115;
    var wait = c.kind === 'join' ? 200 + n * step : 60;
    var ms = c.kind === 'join' ? 620 : 480;
    var format = function (v) {
      return window.theme && typeof window.theme.formatMoney === 'function' && window.theme.moneyWithCurrencyFormat
        ? window.theme.formatMoney(v, window.theme.moneyWithCurrencyFormat) : money(v);
    };
    setTimeout(function () {
      var start = performance.now();
      (function frame(now) {
        if (!document.contains(el)) return;
        var k = Math.min(1, (now - start) / ms);
        var eased = 1 - Math.pow(1 - k, 3);
        el.textContent = format(Math.round(c.from + (to - c.from) * eased));
        if (k < 1) requestAnimationFrame(frame);
      })(start);
    }, wait);
    return wait + ms;
  }

  /* Once, after joining here: the panel opens on the membership and its
     delivery details when the subtotal has settled. A click or key press
     in the meantime calls it off. */
  function openAfterJoin(wait) {
    if (!ui.openAfterJoin || ui.busy) return;
    ui.openAfterJoin = false;
    if (ui.state !== 'joined') return;
    clearTimeout(openTimer);
    openTimer = setTimeout(function () {
      openTimer = null;
      if (ui.state !== 'joined' || ui.busy || ui.open) return;
      ui.open = true;
      applyOpen();
    }, wait || 0);
  }

  function cancelOpen() {
    clearTimeout(openTimer);
    openTimer = null;
  }

  /* ---- events ------------------------------------------------------------ */

  inner.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cd]');
    if (!button || !inner.contains(button)) return;
    if (button.getAttribute('aria-disabled') === 'true') return;
    var action = button.getAttribute('data-cd');
    if (action === 'toggle') {
      ui.open = !ui.open;
      if (!ui.open) ui.info = false;
      applyOpen();
      if (ui.open) {
        track('club_offer_opened', { state: ui.state, bottles: totalBottles(readLines()), member: member || 'none' });
      }
    } else if (action === 'info') {
      ui.info = !ui.info;
      applyOpen();
    } else if (action === 'join') {
      var id = button.getAttribute('data-plan');
      join(id, null, 'Membership added: ' + PLANS[id].name + '.', "Couldn't add the membership. Your cart hasn't changed.");
    } else if (action === 'leave') {
      leave('');
    }
  });

  document.addEventListener('theme:cart:change', function () {
    if (ui.unmark && !ui.busy) {
      marked = false;
      ui.unmark = false;
    }
    render();
    var settle = celebrate();
    sync();
    openAfterJoin(settle);
  });

  fields.addEventListener('input', onDetail);
  fields.addEventListener('change', onDetail);
  document.addEventListener('submit', holdCheckout, true);

  document.addEventListener('theme:cart-drawer:close', function () {
    cancelOpen();
    closePanel();
  });

  document.addEventListener('pointerdown', cancelOpen, true);
  document.addEventListener('keydown', cancelOpen, true);

  /* A click anywhere else in the drawer, or Escape, closes the panel. Escape
     stops there: the drawer's own handler gets the next one. */
  document.addEventListener('click', function (event) {
    if (!ui.open || club.contains(event.target)) return;
    closePanel();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !ui.open) return;
    event.stopPropagation();
    closePanel();
    var toggle = inner.querySelector('[data-cd="toggle"]');
    if (toggle) toggle.focus();
  }, true);

  render();
  sync();
})();
